import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

import { SignatureMchdDtoUI } from "@helper/abstraction/eact";

@Component({
    selector: "app-mchd-popup",
    templateUrl: "./mchd-popup.component.html",
    styleUrls: ["./mchd-popup.component.scss"]
})
export class MchdPopupComponent implements OnInit {
    public mchd?: SignatureMchdDtoUI;
    public showParentMchd = false;

    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef,
    ) { }

    public ngOnInit(): void {
        this.setData();
    }

    public close(): void {
        this.ref.close();
    }

    public getTooltipText(): string {
        return $localize`Более подробную информацию можно просмотреть в файле доверенности. Для этого скачайте архив с документом и откройте файл интересующей доверенности.`;
    }

    private setData(): void {
        this.config.width = "800px";
        this.mchd = this.config.data.mchd;
    }
}
